










import TwoCalender from '@/views/atoms/TwoCalender.vue'
import moment from 'moment'
import ApiClient from '@/common/api'

export default
  components: {
    TwoCalender
  }

  props:
    supplySourceNum:
      type: String
      default: ''

  watch: {
    supplySourceNum: (v) ->
      @supplySource = v
  }

  data: () ->
    supplySource: ''
    month: moment().format('yyyy-MM-DD')
    nextMonth: moment().add('months', 1).format('yyyy-MM-DD')
    toyonakaEvents: []
    suitaEvents: []
    isShowPopup: {}
    start: moment().startOf('month').format('yyyy-MM-DD')
    end: moment().add('months', 1).endOf('month').format('yyyy-MM-DD')

  created: () ->
    @getEvents(@start, @end)
    @supplySource = @supplySourceNum

  methods: {
    clickDate: (date, bool) ->
      if @supplySource == '1'
        if bool
          @toyonakaEvents.push(
            name: '供給不可日'
            start: date.date
            end: date.date
            color: '#505C6A'
            timed: false
            supply_source: @supplySource
          )
          param =
            start: date.date
            end: date.date
            supply_source: @supplySource
          api = new ApiClient()
          await api.post('/admin/not_accepted/save', param)
        else
          start = @toyonakaEvents.map (el) -> el.start
          index = start.indexOf(date.date)
          @toyonakaEvents.splice(index, 1)
          param =
            supply_source: @supplySource
            date: date.date
          api = new ApiClient()
          await api.post('/admin/not_accepted/delete', param)

      if @supplySource == '2'
        if bool
          @suitaEvents.push(
            name: '供給不可日'
            start: date.date
            end: date.date
            color: '#505C6A'
            timed: false
            supply_source: @supplySource
          )
          param =
            start: date.date
            end: date.date
            supply_source: @supplySource
          api = new ApiClient()
          await api.post('/admin/not_accepted/save', param)
        else
          start = @suitaEvents.map (el) -> el.start
          index = start.indexOf(date.date)
          @suitaEvents.splice(index, 1)
          param =
            supply_source: @supplySource
            date: date.date
          api = new ApiClient()
          await api.post('/admin/not_accepted/delete', param)
    showPopup: (property) ->
      @$set(@isShowPopup, property, true)
    closePopup: (property) ->
      @$set(@isShowPopup, property, false)
    monthSwitching: (v) ->
      @getEvents(v.start, v.end)
    getEvents: (start, end) ->
      @start = start
      @end = end
      param =
        start: start
        end: end
      api = new ApiClient()
      data = await api.post('/admin/not_accepted/list', param)
      @toyonakaEvents = data.list[1]
      @suitaEvents = data.list[2]
  }
